import { Corn, getResourceId } from '@eigtech/shared-corn'
import { isClaimCorn } from '@eigtech/shared-corn-helper'
import { useGetClaim } from '../api/claims/getClaim'
import { DelegateAdminClaim } from '../types/DelegateAdminClaim'
import { EntityAdminClaim } from '../types/EntityAdminClaim'
import { canPublishClaimInfoToSymbility } from '../utils/publishing'

export type UseCanPublishClaimInfoToSymbilityProps =
  | { claim: DelegateAdminClaim | EntityAdminClaim | undefined }
  | { claimNumber: string }
  | { claimCorn: Corn }

export function useCanPublishClaimInfoToSymbility(props: UseCanPublishClaimInfoToSymbilityProps) {
  const claimNumber =
    'claimNumber' in props
      ? props.claimNumber
      : 'claimCorn' in props
        ? // only get resource id if for sure is claim corn
          isClaimCorn(props.claimCorn)
          ? getResourceId(props.claimCorn)
          : ''
        : // use empty string if no claimNumber or claimCorn in props
          ''

  const { data: claim } = useGetClaim<DelegateAdminClaim | EntityAdminClaim>(claimNumber)

  return canPublishClaimInfoToSymbility('claim' in props ? props.claim : claim)
}
